import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (id) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_BLOCKED_DEPARTMENT',
    method: 'PUT',
  });
  useEffect(() => {
    if (id) {
      exec({ url: `/api/blocked_department`, data: id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return [isRequestSuccessed, exec];
});
